import {
  CloudUpload as CloudUploadIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  Receipt as ReceiptIcon,
} from "@mui/icons-material";
import { IconProps, SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import React from "react";

type IconMapperType = { [key: string]: OverridableComponent<SvgIconTypeMap> };

const iconsMapper: IconMapperType = {
  edit: EditIcon,
  trash: DeleteIcon,
  power: PowerSettingsNewIcon,
  cloudUpload: CloudUploadIcon,
  receipt: ReceiptIcon,
};

interface ExtendedIconProps extends IconProps {
  name: keyof typeof iconsMapper;
}

const Icon: React.FC<ExtendedIconProps> = ({ name, ...props }) => {
  const Comp: any = iconsMapper[name];

  return <Comp cursor={"pointer"} fontSize={"small"} {...props} />;
};

export default Icon;
